import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Space, Table, Typography } from "antd";
import moment from "moment";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";
import AdminListContainer from "../../containers/adminRole/admin/AdminListContainer";
import { deleteApi, getApis } from "../../appRedux/actions/Api";

export default function ApiExternalPage() {
  const [apis, setApis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const ExpiredBackgroundColor = "#faf70d";

  const loadApis = () => {
    setLoading(true);
    getApis().then((data) => {
      const apiList = data?.data || [];
      setApis(apiList);
      // Default expand all rows that contain roles
      const keys = apiList
        .filter((item) => item.roles && item.roles !== "[]")
        .map((item) => item.id);
      setExpandedRowKeys(keys);
      setLoading(false);
    });
  };

  useEffect(() => {
    loadApis();
  }, []);

  const handleDelete = (id) => {
    deleteApi(id).then(() => loadApis());
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      align: "center",
      responsive: ["sm"],
      width: 1,
      render: (id, record) => {
        const isExpired = moment(record.expired_at).isBefore(moment());
        return {
          props: {
            style: { background: isExpired ? ExpiredBackgroundColor : "" },
          },
          children: id,
        };
      },
    },
    {
      title: "Nama",
      dataIndex: "name",
      render: (name, item) => {
        const isExpired = moment(item.expired_at).isBefore(moment());
        return {
          props: {
            style: { background: isExpired ? ExpiredBackgroundColor : "" },
          },
          children: <div>{name}</div>,
        };
      },
    },
    {
      title: "Expired",
      dataIndex: "expired_at",
      render: (expired_at, item) => {
        const isExpired = moment(expired_at).isBefore(moment());
        return {
          props: {
            style: { background: isExpired ? ExpiredBackgroundColor : "" },
          },
          children: <div>{moment(expired_at).local().format("YYYY-MM-DD HH:mm:ss")}</div>,
        };
      },
    },
    {
      title: "Token",
      dataIndex: "key",
      render: (key, item) => {
        const isExpired = moment(item.expired_at).isBefore(moment());
        return {
          props: {
            style: { background: isExpired ? ExpiredBackgroundColor : "" },
          },
          children: (
            <Space>
              <Typography.Text
                copyable={{
                  text: key,
                }}
              >
                {key?.substring(0, 16)}...
              </Typography.Text>
            </Space>
          ),
        };
      },
    },
    {
      title: "Aksi",
      align: "center",
      width: 1,
      render: (_, record) => {
        const isExpired = moment(record.expired_at).isBefore(moment());
        return {
          props: {
            style: { background: isExpired ? ExpiredBackgroundColor : "" },
          },
          children: (
            <Space>
              <Link to={`/api-external/${record.id}/edit`}>
                <Button
                  type="link"
                  icon={<EditOutlined />}
                  style={{ margin: 0, padding: 0 }}
                />
              </Link>
              <Popconfirm
                title="Apakah yakin akan menghapus credential ini?"
                onConfirm={() => handleDelete(record.id)}
              >
                <Button
                  type="link"
                  danger
                  icon={<DeleteOutlined />}
                  style={{ margin: 0, padding: 0 }}
                />
              </Popconfirm>
            </Space>
          ),
        };
      },
    },
  ];

  return (
    <PageContentWrapper
      backLink="/admin"
      title="Credential Api External"
      extra={
        <Space>
          <Link to="/api-external/add">
            <Button icon={<PlusOutlined />} type="primary" style={{ margin: 0 }}>
              Tambah
            </Button>
          </Link>
        </Space>
      }
    >
      <Table
        dataSource={apis}
        columns={columns}
        loading={loading}
        pagination={false}
        rowKey="id"
        expandable={{
          expandedRowKeys,
          onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
          expandedRowRender: (record) => {
            let roles = [];
            try {
              roles = JSON.parse(record.roles);
            } catch (e) {
              return <Typography.Text type="danger">Format role tidak valid</Typography.Text>;
            }
            return (
              <Table
                size="small"
                pagination={false}
                dataSource={roles}
                rowKey="key"
                columns={[
                  { title: "Path", dataIndex: "path", width: 240 },
                  { title: "Read/GET", dataIndex: "GET", align: "center", render: (val) => (val ? "✔" : "-") },
                  { title: "Write/POST", dataIndex: "POST", align: "center", render: (val) => (val ? "✔" : "-") },
                  { title: "Update/PUT", dataIndex: "PUT", align: "center", render: (val) => (val ? "✔" : "-") },
                  { title: "Delete/DELETE", dataIndex: "DELETE", align: "center", render: (val) => (val ? "✔" : "-") },
                ]}
              />
            );
          },
          rowExpandable: (record) => record.roles && record.roles !== "[]",
        }}
      />
    </PageContentWrapper>
  );
}
